export interface FilterDisplaySettings {
  name?: string;
  color: string;
}

export const filterSettings: Record<string, FilterDisplaySettings> = {
  L: { name: "L", color: "#ffffff" },
  R: { name: "R", color: "#ff0000" },
  G: { name: "G", color: "#00ff00" },
  B: { name: "B", color: "#0000ff" },
  Ha: { name: "Ha", color: "#e573e5" },
  Oiii: { name: "Oiii", color: "#00bfff" },
  Sii: { name: "Sii", color: "#ffffff" },
  // Add more as needed
};
